import React from "react";

export const VerticalLineIcon = ({ size = 13, fill = "#29394D" }) => (
    <svg
    width="7"
    height="16"
    viewBox="0 0 7 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" width="1" height="16" rx="0.5" fill="#B6BFC8" />
    <rect x="3" width="1" height="16" rx="0.5" fill="#B6BFC8" />
    <rect width="1" height="16" rx="0.5" fill="#B6BFC8" />
  </svg>
);
